// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3rveW","rootCenter":"LoadMoreObserver_rootCenter__2dlzW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__W2QCR"};